/* AIRBIRTH LP — vanilla interactivity (hero montage, diagnosis quiz, movie, scroll reveal) */
(function () {
  'use strict';

  function safe(fn, root) {
    try { fn(root); } catch (e) { if (window.console) console.error('[airbirth-lp]', e); }
  }

  function init(root) {
    if (!root || root.dataset.abInit === '1') return;
    root.dataset.abInit = '1';

    safe(initReveal, root);
    safe(initHero, root);
    safe(initDiagnosis, root);
    safe(initMovie, root);
    safe(initInfoCardCarousels, root);
    safe(initSceneCarousel, root);
  }

  /* ---------- Cinematic hero ---------- */
  function initHero(root) {
    var hero = root.querySelector('.hero-cinematic');
    if (!hero) return;

    var scenes = Array.prototype.slice.call(hero.querySelectorAll('.hero-cine-scene'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('.hcd'));
    var pauseBtn = hero.querySelector('.hero-cine-pause');
    var capEn = hero.querySelector('.hero-cine-caption .cap-en');
    var capJp = hero.querySelector('.hero-cine-caption .cap-jp');
    var caption = hero.querySelector('.hero-cine-caption');
    var count = scenes.length;
    if (!count) return;

    var captions = [];
    try {
      var dataEl = hero.querySelector('#ab-hero-captions');
      if (dataEl) captions = JSON.parse(dataEl.textContent);
    } catch (e) { captions = []; }

    var DURATION = 5200;
    var idx = 0;
    var paused = false;
    var timer = null;

    function renderCaption(i) {
      var c = captions[i];
      if (!c || !capEn || !capJp) return;
      capEn.textContent = c.en;
      capEn.style.color = c.accent;
      capJp.textContent = '— ' + c.jp;
      if (caption) {
        caption.style.color = c.accent;
        // restart the slide-in animation
        caption.style.animation = 'none';
        // force reflow
        void caption.offsetWidth;
        caption.style.animation = '';
      }
    }

    function show(i) {
      idx = (i + count) % count;
      scenes.forEach(function (s, n) { s.classList.toggle('active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('active', n === idx); });
      renderCaption(idx);
    }

    function start() {
      stop();
      if (paused) return;
      timer = setInterval(function () { show(idx + 1); }, DURATION);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { show(n); start(); });
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.textContent = paused ? '▶' : '❚❚';
        pauseBtn.setAttribute('aria-label', paused ? '再生' : '一時停止');
        var fill = hero.querySelector('.hcd.active .hcd-fill');
        if (fill) fill.style.animationPlayState = paused ? 'paused' : 'running';
        if (paused) stop(); else start();
      });
    }

    show(0);
    start();

    // pause the rotation when hero is offscreen (perf)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !paused) start(); else stop();
        });
      }, { threshold: 0.15 });
      io.observe(hero);
    }
  }

  /* ---------- Diagnosis quiz ---------- */
  function diagnoseProduct(a) {
    var scene = a.scene, priority = a.priority, shape = a.shape;
    if (shape === 'cap') return 'crown-braid-cap';
    if (shape === 'wide') return priority === 'casual' ? 'pleated-brim' : 'capeline';
    if (shape === 'breton') return 'summer-tweed';
    if (priority === 'elegant' || scene === 'travel') return 'braid-grosgrain';
    if (priority === 'uv' || scene === 'garden') return 'capeline';
    if (priority === 'casual' || scene === 'walk') return 'ramie-cloche';
    return 'pleated-brim';
  }

  function initDiagnosis(root) {
    var diag = root.querySelector('.diagnosis-card');
    if (!diag) return;

    var steps = Array.prototype.slice.call(diag.querySelectorAll('.airbirth-diag-step'));
    var results = Array.prototype.slice.call(diag.querySelectorAll('.diag-result'));
    var progress = Array.prototype.slice.call(diag.querySelectorAll('.diag-progress .step'));
    var order = ['scene', 'priority', 'shape'];
    var total = steps.length;
    var answers = {};
    var current = 0;

    function paintProgress() {
      var isResult = current >= total;
      progress.forEach(function (p, i) {
        p.classList.remove('done', 'current');
        if (isResult || i < current) p.classList.add('done');
        else if (i === current) p.classList.add('current');
      });
    }

    function render() {
      var isResult = current >= total;
      steps.forEach(function (s, i) { s.hidden = isResult || i !== current; });
      results.forEach(function (r) { r.hidden = true; });
      if (isResult) {
        var id = diagnoseProduct(answers);
        var match = results.filter(function (r) { return r.dataset.product === id; })[0] || results[0];
        if (match) match.hidden = false;
      }
      paintProgress();
    }

    steps.forEach(function (step, i) {
      var qid = order[i];
      step.querySelectorAll('.diag-opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          step.querySelectorAll('.diag-opt').forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          answers[qid] = btn.dataset.value;
          setTimeout(function () { current = Math.min(total, current + 1); render(); }, 220);
        });
      });
      var back = step.querySelector('.diag-back');
      if (back) back.addEventListener('click', function () { current = Math.max(0, current - 1); render(); });
    });

    results.forEach(function (r) {
      var restart = r.querySelector('.diag-restart-btn');
      if (restart) restart.addEventListener('click', function () { current = 0; answers = {}; render(); });
    });

    render();
  }

  /* ---------- Movie ---------- */
  function initMovie(root) {
    var frame = root.querySelector('.movie-frame');
    if (!frame) return;
    var play = frame.querySelector('.movie-play');
    if (!play) return;

    play.addEventListener('click', function () {
      var video = frame.querySelector('video');
      frame.classList.add('is-playing');
      if (video) {
        video.style.display = 'block';
        if (video.play) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      }
    });
  }

  /* ---------- Scenes carousel ---------- */
  function updateCarouselCounter(counter, currentIndex, total) {
    if (!counter) return;
    var current = counter.querySelector('[data-carousel-current]');
    var totalEl = counter.querySelector('[data-carousel-total]');
    if (current) current.textContent = String(currentIndex + 1);
    if (totalEl) totalEl.textContent = String(total);
  }

  function bindActiveCards(row, selector) {
    var cards = Array.prototype.slice.call(row.querySelectorAll(selector));
    if (!cards.length) return null;
    var counter = row.nextElementSibling && row.nextElementSibling.matches('[data-carousel-counter]') ? row.nextElementSibling : null;
    var activeIndex = 0;
    var raf = null;

    function setActive(index) {
      activeIndex = Math.max(0, Math.min(cards.length - 1, index));
      cards.forEach(function (card, n) {
        var active = n === activeIndex;
        card.classList.toggle('is-active', active);
        if (active) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });
      updateCarouselCounter(counter, activeIndex, cards.length);
    }

    function nearestIndex() {
      if (row.scrollLeft < 4) return 0;
      var rect = row.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var closest = 0;
      var closestDistance = Infinity;
      cards.forEach(function (card, n) {
        var cardRect = card.getBoundingClientRect();
        var cardCenter = cardRect.left + cardRect.width / 2;
        var distance = Math.abs(center - cardCenter);
        if (distance < closestDistance) {
          closest = n;
          closestDistance = distance;
        }
      });
      return closest;
    }

    function update() {
      raf = null;
      setActive(nearestIndex());
    }

    function requestUpdate() {
      if (raf) return;
      raf = window.requestAnimationFrame ? window.requestAnimationFrame(update) : setTimeout(update, 16);
    }

    function scrollToIndex(index) {
      var target = cards[Math.max(0, Math.min(cards.length - 1, index))];
      if (!target) return;
      var left = target.offsetLeft - ((row.clientWidth - target.clientWidth) / 2);
      row.scrollTo({ left: left, behavior: 'smooth' });
      setActive(cards.indexOf(target));
    }

    setActive(0);
    row.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    setTimeout(update, 120);

    return {
      getActiveIndex: function () { return activeIndex; },
      scrollToIndex: scrollToIndex
    };
  }

  function initInfoCardCarousels(root) {
    root.querySelectorAll('[data-card-carousel]').forEach(function (row) {
      bindActiveCards(row, 'figure');
    });
  }

  function initSceneCarousel(root) {
    root.querySelectorAll('[data-scene-carousel]').forEach(function (c) {
      var row = c.querySelector('.scene-row');
      if (!row || row.dataset.sceneLoopInit === '1') return;
      row.dataset.sceneLoopInit = '1';

      var prev = c.querySelector('.scene-nav--prev');
      var next = c.querySelector('.scene-nav--next');
      var counter = c.querySelector('[data-carousel-counter]');
      var originals = Array.prototype.slice.call(row.querySelectorAll('.scene-card-v2'));
      var count = originals.length;
      if (!count) return;

      var canLoop = count > 1;
      var activeIndex = 0;
      var raf = null;
      var settleTimer = null;
      var isJumping = false;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      originals.forEach(function (card, n) {
        card.dataset.sceneIndex = String(n);
        card.dataset.sceneClone = 'false';
      });

      function prepareClone(card, index) {
        card.dataset.sceneIndex = String(index);
        card.dataset.sceneClone = 'true';
        card.classList.add('scene-card-clone');
        card.setAttribute('aria-hidden', 'true');
        card.setAttribute('tabindex', '-1');
      }

      if (canLoop) {
        var headClone = originals[count - 1].cloneNode(true);
        var tailClone = originals[0].cloneNode(true);
        prepareClone(headClone, count - 1);
        prepareClone(tailClone, 0);
        row.insertBefore(headClone, originals[0]);
        row.appendChild(tailClone);
      }

      var cards = Array.prototype.slice.call(row.querySelectorAll('.scene-card-v2'));
      var firstRealPosition = canLoop ? 1 : 0;
      var lastRealPosition = canLoop ? cards.length - 2 : 0;

      function normalizeIndex(index) {
        return ((index % count) + count) % count;
      }

      function sceneIndex(card) {
        var value = parseInt(card.dataset.sceneIndex, 10);
        return isNaN(value) ? 0 : value;
      }

      function setActive(index) {
        activeIndex = normalizeIndex(index);
        cards.forEach(function (card) {
          var active = sceneIndex(card) === activeIndex;
          var clone = card.dataset.sceneClone === 'true';
          card.classList.toggle('is-active', active);
          if (active && !clone) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
        });
        updateCarouselCounter(counter, activeIndex, count);
      }

      function nearestPosition() {
        var rect = row.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var closest = firstRealPosition;
        var closestDistance = Infinity;
        cards.forEach(function (card, n) {
          var cardRect = card.getBoundingClientRect();
          var cardCenter = cardRect.left + cardRect.width / 2;
          var distance = Math.abs(center - cardCenter);
          if (distance < closestDistance) {
            closest = n;
            closestDistance = distance;
          }
        });
        return closest;
      }

      function positionForIndex(index) {
        return canLoop ? normalizeIndex(index) + 1 : normalizeIndex(index);
      }

      function scrollToPosition(position, behavior) {
        var target = cards[Math.max(0, Math.min(cards.length - 1, position))];
        if (!target) return;
        var left = target.offsetLeft - ((row.clientWidth - target.clientWidth) / 2);
        var mode = reduceMotion ? 'auto' : (behavior || 'smooth');
        if (!row.scrollTo) {
          row.scrollLeft = left;
          return;
        }
        try {
          row.scrollTo({ left: left, behavior: mode });
        } catch (e) {
          row.scrollLeft = left;
        }
      }

      function updateFromScroll() {
        raf = null;
        var card = cards[nearestPosition()];
        if (card) setActive(sceneIndex(card));
      }

      function requestUpdate() {
        if (raf) return;
        raf = window.requestAnimationFrame ? window.requestAnimationFrame(updateFromScroll) : setTimeout(updateFromScroll, 16);
      }

      function normalizeLoopEdge() {
        if (!canLoop) return;
        var position = nearestPosition();
        if (position === 0) {
          isJumping = true;
          setActive(count - 1);
          scrollToPosition(lastRealPosition, 'auto');
          setTimeout(function () { isJumping = false; }, 40);
        } else if (position === cards.length - 1) {
          isJumping = true;
          setActive(0);
          scrollToPosition(firstRealPosition, 'auto');
          setTimeout(function () { isJumping = false; }, 40);
        }
      }

      function handleScroll() {
        if (isJumping) return;
        requestUpdate();
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(normalizeLoopEdge, 150);
      }

      function go(delta) {
        if (!canLoop) {
          scrollToPosition(0, 'smooth');
          return;
        }

        var currentCard = cards[nearestPosition()];
        var currentIndex = currentCard ? sceneIndex(currentCard) : activeIndex;
        if (delta > 0 && currentIndex === count - 1) {
          setActive(0);
          scrollToPosition(cards.length - 1, 'smooth');
          return;
        }
        if (delta < 0 && currentIndex === 0) {
          setActive(count - 1);
          scrollToPosition(0, 'smooth');
          return;
        }

        var nextIndex = normalizeIndex(currentIndex + delta);
        setActive(nextIndex);
        scrollToPosition(positionForIndex(nextIndex), 'smooth');
      }

      setActive(0);
      scrollToPosition(firstRealPosition, 'auto');
      row.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', function () {
        scrollToPosition(positionForIndex(activeIndex), 'auto');
      });
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      setTimeout(function () { scrollToPosition(positionForIndex(activeIndex), 'auto'); }, 120);
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('.reveal'));
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- boot ---------- */
  function boot() {
    document.querySelectorAll('[data-airbirth-lp]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // re-init in Shopify theme editor
  document.addEventListener('shopify:section:load', boot);
})();
